export default __webpack_public_path__ + "static/media/img_18.b65d2084.jpg";